export enum Locale {
    ES = "es",
    EN_US = "en-US"
}
